// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"a040bbd2","335":"dae76e3e","351":"35030115","833":"6e7c283b","872":"345ad745"}[chunkId] + ".chunk.js";
};